import {
	Box,
	Card,
	CardContent,
	CardHeader,
	Grid,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDataProvider } from "react-admin";

interface Stats {
	apps: number;
	partners: number;
	users: number;
	referralLinks: number;
}

export const Dashboard = () => {
	const dataProvider = useDataProvider();
	const [stats, setStats] = useState<Stats>({
		apps: 0,
		partners: 0,
		users: 0,
		referralLinks: 0,
	});
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchStats = async () => {
			try {
				const [apps, partners, users, referralLinks] = await Promise.all([
					dataProvider.getList("apps", {
						pagination: { page: 1, perPage: 1 },
						sort: { field: "createdAt", order: "DESC" },
						filter: {},
					}),
					dataProvider.getList("partners", {
						pagination: { page: 1, perPage: 1 },
						sort: { field: "createdAt", order: "DESC" },
						filter: {},
					}),
					dataProvider.getList("users", {
						pagination: { page: 1, perPage: 1 },
						sort: { field: "createdAt", order: "DESC" },
						filter: {},
					}),
					dataProvider.getList("referral-links", {
						pagination: { page: 1, perPage: 1 },
						sort: { field: "createdAt", order: "DESC" },
						filter: {},
					}),
				]);

				setStats({
					apps: apps.total ?? 0,
					partners: partners.total ?? 0,
					users: users.total ?? 0,
					referralLinks: referralLinks.total ?? 0,
				});
			} catch (error) {
				console.error("Failed to fetch stats:", error);
			} finally {
				setLoading(false);
			}
		};

		fetchStats();
	}, [dataProvider]);

	if (loading) {
		return (
			<Box sx={{ p: 3 }}>
				<Typography>Loading dashboard...</Typography>
			</Box>
		);
	}

	return (
		<Box sx={{ p: 3 }}>
			<Typography variant="h4" gutterBottom>
				Dashboard
			</Typography>
			<Grid container spacing={3}>
				<Grid size={{ xs: 12, sm: 6, md: 3 }}>
					<StatCard title="Apps" value={stats.apps} color="#1976d2" />
				</Grid>
				<Grid size={{ xs: 12, sm: 6, md: 3 }}>
					<StatCard title="Partners" value={stats.partners} color="#388e3c" />
				</Grid>
				<Grid size={{ xs: 12, sm: 6, md: 3 }}>
					<StatCard title="Users" value={stats.users} color="#f57c00" />
				</Grid>
				<Grid size={{ xs: 12, sm: 6, md: 3 }}>
					<StatCard
						title="Referral Links"
						value={stats.referralLinks}
						color="#7b1fa2"
					/>
				</Grid>
			</Grid>
		</Box>
	);
};

interface StatCardProps {
	title: string;
	value: number;
	color: string;
}

const StatCard = ({ title, value, color }: StatCardProps) => (
	<Card>
		<CardHeader
			title={title}
			sx={{
				backgroundColor: color,
				color: "white",
				"& .MuiCardHeader-title": { fontSize: "1rem" },
			}}
		/>
		<CardContent>
			<Typography variant="h3" component="div" sx={{ textAlign: "center" }}>
				{value.toLocaleString()}
			</Typography>
		</CardContent>
	</Card>
);
